import { Injectable } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { BUCKET_URL } from "src/app/_shared/utils/constants";
import { Pricing, Service, ServicePackaging } from "../../interface";



@Injectable()
export class ServiceFormService {
  serviceFormGroup: FormGroup;
  service = new BehaviorSubject<Service | undefined>(undefined)
  constructor(
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  public createForm() {
    this.serviceFormGroup = this.fb.group({
      category_id: ['', [Validators.required]],
      country_id: ['', [Validators.required]],
      default_package: [''],
      icon: [''],
      name: ['', [Validators.required]],
      packaging: this.fb.array([]),
      published: [false],
      region_scoping: [[]],
      service_provider_id: ['', [Validators.required]],
      tags: [[]],
      unit_of_measure_id: ['', [Validators.required]],
      show_discount: [false,],
      discount_rate: [0],
      transport: this.fb.group({
        service_center: [''],
        base_radius_in_km: [''],
        base_transport: [''],
        cost_per_extra_km: ['']
      })
    });
    this.service.next(undefined)
  }

  patchFormGroup(service: Service) {
    this.createForm();
    const icon = service.icon.split(BUCKET_URL)
    let iconUrl: string
    if (icon.length == 2) {
      iconUrl = icon[1]
    }
    else {
      iconUrl = icon[0]
    }
    this.service.next(service)
    const payload = {
      // category_id: service.category.id,
      country_id: service.country.id,
      default_package: 0,
      icon: iconUrl,
      name: service.name,
      published: service.published,
      // region_scoping: service.region_scoping,
      // service_provider_id: service.service_provider.id,
      tags: service.tags,
      // unit_of_measure_id: service.unit_of_measure.id,
      show_discount: service.discount ? service.discount.show : false,
      discount_rate: service.discount ? service.discount.rate : 0,
    }
    if (service.packaging) {
      this.addPackaging(service.packaging)
    }
    if(service.transport){
      payload['transport'] = {
        service_center: service.transport.service_center,
        base_radius_in_km: service.transport.base_radius_in_km,
        base_transport: service.transport.base_transport,
        cost_per_extra_km: service.transport.cost_per_extra_km
      }
    }
    this.serviceFormGroup.patchValue(payload);
  }

  public get service$() {
    return this.service.asObservable()
  }

  public get packagingForm(): FormArray {
    return this.serviceFormGroup.get("packaging") as FormArray;
  }

  public get regionScopingForm(): FormArray {
    return this.serviceFormGroup.get("region_scoping") as FormArray;
  }

  public get transportFormGroup() {
    return this.serviceFormGroup.get('transport') as FormGroup
  }

  public addControl(data: ServicePackaging) {
    const group = this.fb.group({
      description: [data.description],
      minimum_order: [data.minimum_order || 1, [Validators.required, Validators.min(1)]],
      name: [data.name, [Validators.required, Validators.minLength(2)]],
      price: [data.price, [Validators.required, Validators.min(0)]],
      pricing: this.fb.array([]),
    });
    if (data.pricing) {
      const pricing = group.controls.pricing as FormArray;
      data.pricing.map(val => {
        this.addPriceTier(val, pricing);
      })
    }
    return group;
  }

  public addPackaging(data: ServicePackaging[]) {
    data.forEach((x) => {
      this.packagingForm.push(this.addControl(x));
    });
  }

  public addPriceTier(value: Pricing, control: FormArray) {
    control.push(this.fb.group({
      price: [value.price, [Validators.required, Validators.min(0)]],
      min: [value.min, [Validators.required, Validators.min(1)]],
    }));
  }

  public setDefaultPackage(value: number) {
    this.serviceFormGroup.get("default_package").patchValue(value);
  }

  public get unitofMeasureIdControl() {
    return this.serviceFormGroup.get("unit_of_measure_id")
  }
}
